import { Box, Stack, Typography } from '@mui/material'

const DriverNew = () => {
  return (
    <Box p={2}>
      <Stack spacing={2}>
        <Typography variant="h6" fontWeight="bold">
          Thanks for adding a driver!
        </Typography>
        <Typography>
          The driver will receive a text message with a link to download the
          app.
        </Typography>
        <Typography>
          Once the driver downloads the app and completes registration, you can
          dispatch an order.
        </Typography>
      </Stack>
    </Box>
  )
}

export default DriverNew


